import { render, staticRenderFns } from "./NotifierBlock.vue?vue&type=template&id=63e6f39a&"
import script from "./NotifierBlock.vue?vue&type=script&lang=js&"
export * from "./NotifierBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports